/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://conformimf.com/
* Copyright 2023 Creative Tim (https://conformimf.com)

Coded by conformimf.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function Footer() {
  return (
    <MDBox component="footer" py={4} textAlign="center">
      <MDTypography variant="button" color="secondary">
        &copy; 2026 ConformIMF - Système de Veille Réglementaire
      </MDTypography>
    </MDBox>
  );
}

export default Footer;
